module.exports = __webpack_public_path__ + "static/map_usa_SO_hover-7584ce8d9bc376afd6740453ffca8589.png";